import { render, staticRenderFns } from "./ChannelItems.vue?vue&type=template&id=01abd6b7&scoped=true&"
import script from "./ChannelItems.vue?vue&type=script&lang=js&"
export * from "./ChannelItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01abd6b7",
  null
  
)

export default component.exports